import React from 'react';
import './CurvedHeader.css';

export default function CurvedHeader({
  title,
  pillTextBold,
  pillTextLight,
  pills,
  backgroundColor = '#1a1a1a',
  titleColor = 'white',
  pillBackgroundColor = 'white',
  pillTextColor = '#1a1a1a',
  pillIconBackgroundColor = '#1a1a1a',
  pillIconColor = 'white',
  arrowColor = 'white',
  onArrowClick,
}) {
  const displayPills =
    pills ||
    (pillTextBold || pillTextLight
      ? [
          {
            titleBold: pillTextBold,
            textLight: pillTextLight,
            icon: (
              <svg
                viewBox='0 0 24 24'
                fill='none'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              >
                <path d='M23 6l-9.5 9.5-5-5L1 18' />
                <path d='M17 6h6v6' />
              </svg>
            ),
          },
        ]
      : []);

  return (
    <div className='curved-header' style={{ color: titleColor }}>
      <h2 className='curved-header__title'>{title}</h2>
      <div className='curved-header__pills-container'>
        {displayPills.map((pill, idx) => (
          <div
            key={idx}
            className='curved-header__pill'
            style={{ backgroundColor: pillBackgroundColor, color: pillTextColor }}
          >
            {pill.titleBold && <strong>{pill.titleBold}</strong>}
            <span
              className='curved-header__pill-icon'
              style={{ backgroundColor: pillIconBackgroundColor, color: pillIconColor }}
            >
              {pill.icon}
            </span>
            {pill.textLight && <span>{pill.textLight}</span>}
          </div>
        ))}
      </div>
      <div className='curved-header__bottom-mask'>
        <svg
          viewBox='0 0 1440 337'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          preserveAspectRatio='none'
        >
          <path
            d='M1441 0H0V287.861H622.06C641.296 287.861 659.486 296.62 671.48 311.659L672.687 313.172C697.729 344.569 745.614 344.057 769.978 312.131C781.651 296.836 799.79 287.861 819.03 287.861H1441V0Z'
            fill={backgroundColor}
          />
        </svg>
      </div>
      <div
        className='curved-header__arrow-down-container'
        onClick={onArrowClick}
        style={{ cursor: onArrowClick ? 'pointer' : 'default' }}
      >
        <div className='curved-header__arrow-down' style={{ color: arrowColor }}>
          <svg viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1'>
            <path d='M12 4v16' />
            <path d='M5 13l7 7 7-7' />
          </svg>
        </div>
      </div>
    </div>
  );
}
